import * as React from 'react';
import {useState} from "react";

import classNames from 'classnames';
import styled from "styled-components";

import {Colors, Fonts, MediaBreakpoints} from "../../Styles";
import {AccountIndicator} from '../AccountIndicator/AccountIndicator';
import '../../Styles/layout/header.sass';
import {Logo} from "../Logo/Logo";

const StyledHeader = styled.header`
    background-color: ${Colors.supernova};
    padding: 0 5px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    font-family: ${Fonts.theinhardt};
    font-size: 14px;
    color: ${Colors.mineShaft};

    @media ${MediaBreakpoints.medium} {
        padding: 0 48px;
    }

    .logo {
        height: 32px;
        padding: 14px 0;
    }
`;

const MenuButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    font-size: 34px;
    font-weight: 400;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;

    &--close {
        position: static;
        transform: translateY(0);
        font-size: 26px;
        font-weight: 700;
    }

    &:focus {
        background: transparent;
        outline: none;
    }

    @media ${MediaBreakpoints.medium} {
        right: 48px;
    }

    @media ${MediaBreakpoints.wide} {
        display: none;
    }
`;

MenuButton.displayName = "menuButton"

export const Header: React.FC<React.PropsWithChildren<{}>> = (props: React.PropsWithChildren<{}>) => {
    const [menuVisible, setMenuVisible] = useState(false)

    return (
        <StyledHeader>
            <div className="logo"><Logo/></div>
                <MenuButton onClick={() => setMenuVisible(true)}>︙</MenuButton>
            <div className={
                classNames('main-navigation-mobile', {
                    'main-navigation-mobile--visible': menuVisible
                })
            }>
                <header className="main-navigation-mobile__header">
                    <button className="main-navigation-toggle main-navigation-toggle--close" onClick={() => setMenuVisible(false)}>╳</button>
                </header>
                {props.children}
                <AccountIndicator/>
            </div>
        </StyledHeader>
    );
};